import styled from 'styled-components'

export const Name = styled.div`
  font-family: roboto;
  font-size: 16px;
  font-weight: 700;
  display: flex;
  gap: 8px;
  margin: 0 20px;
  svg {
    background: white;
    color: #213f68;
    border-radius: 8px;
    padding: 4px 6px;
  }
`

export const Details = styled.div`
  font-family: roboto;
  font-size: 14px;
  margin: 0 20px;
  > div {
    display: flex;
    align-items: center;
    gap: 8px;
    margin-top: 16px;
    svg {
      border-radius: 8px;
      padding: 4px;
      width: 16px;
      height: 16px;
    }
    div {
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }
`
